export const viewActionTypes = {
    ALBUM_IMAGE_REQUESTED: 'ALBUM_IMAGE_REQUESTED',
    ALBUM_IMAGE_RECEIVED: 'ALBUM_IMAGE_RECEIVED',
    ALBUM_IMAGE_FAILED: 'ALBUM_IMAGE_FAILED',
    ALBUM_ITEMS_SLIDER_REQUEST: 'ALBUM_ITEMS_SLIDER_REQUEST',
    ALBUM_IMAGE_CURRENT_UPDATED: 'ALBUM_IMAGE_CURRENT_UPDATED',
    CLEAR_ALBUM_ITEM_SELECTION: 'CLEAR_ALBUM_ITEM_SELECTION',
    CLEAR_ALBUM_ITEMS_SLIDER: 'CLEAR_ALBUM_ITEMS_SLIDER',
    TOGGLE_SLIDE_SHOW: 'TOGGLE_SLIDE_SHOW',
    TOGGLE_RIGHT_OPEN: 'TOGGLE_RIGHT_OPEN',
    UPDATE_CURRENT_ITEM_SHOWN_MEDIA_PLAYER: 'UPDATE_CURRENT_ITEM_SHOWN_MEDIA_PLAYER',
    TOGGLE_ROTATE: 'TOGGLE_ROTATE',
    TOGGLE_VIDEO_EDITOR: 'TOGGLE_VIDEO_EDITOR'
   
};


// WEBPACK FOOTER //
// ./src/view/actions/view-action-types.js